module.exports = __webpack_public_path__ + "img/apple-icon-114x114.b83fa3ba.png";